export { default } from "./AdminConsoleFacultyAdderTeacherSection";
